<template>
  <div class="shjjzb">
    <div class="operate">
      <div class="title">
        <span class="yuan"></span>2000-2030年{{ this.city }}重金属数据
      </div>
      <div class="echarts1" ref="echarts1"></div>
      <div class="echarts2" ref="echarts2"></div>
    </div>
    <div class="mapBox">
      <div class="title"><span class="yuan"></span>长三角总重金属污染数据</div>
      <div class="map" ref="map"></div>
      <el-date-picker
        class="mapYear"
        v-model="defaultYear"
        size="small"
        type="year"
        placeholder=""
        @change="handleChangeMapYear"
        :picker-options="pickerOptions"
        :clearable="false"
      >
      </el-date-picker>
    </div>
    <div class="echartsBox">
      <div class="title">
        <span class="yuan"></span>{{this.year}}{{ this.city }}重金属健康风险评估

      </div>
      <div class="glzb">
        <div class="glzb_line">
          <div class="echarts3 glzb_line_item" ref="echarts3"></div>
          <div class="echarts4 glzb_line_item" ref="echarts4"></div>
        </div>
        <div class="glzb_line">
          <div class="echarts5 glzb_line_item" ref="echarts5"></div>
          <div class="echarts6 glzb_line_item" ref="echarts6"></div>
        </div>
      </div>
      <div class="zaTable">
        <table  border="1px solid #ccc" cellspacing="0" cellpadding="0" >
          <tr class="lin1" v-if="tableshow2">
            <td class="td1">{{ this.city }}</td>
            <td>经口摄入</td>
            <td>呼吸吸入</td>
            <td>皮肤接触</td>
            <td>是否存在风险</td>
          </tr>
          <tr v-if="tableshow2">
            <td  class="td1">儿童非致癌</td>
            <td>{{ this.lin1List[0] }}</td>
            <td>{{ this.lin1List[1] }}</td>
            <td>{{ this.lin1List[2] }}</td>
            <td>{{ this.lin1List[3] }}</td>
          </tr>
          <tr v-if="tableshow1">
            <td  class="td1">儿童致癌</td>
            <td>{{ this.lin2List[0] }}</td>
            <td>{{ this.lin2List[1] }}</td>
            <td>{{ this.lin2List[2] }}</td>
            <td>{{ this.lin2List[3] }}</td>
          </tr>
          <tr v-if="tableshow2">
            <td  class="td1">成人非致癌</td>
            <td>{{ this.lin3List[0] }}</td>
            <td>{{ this.lin3List[1] }}</td>
            <td>{{ this.lin3List[2] }}</td>
            <td>{{ this.lin3List[3] }}</td>
          </tr>
          <tr v-if="tableshow1">
            <td  class="td1">成人致癌</td>
            <td>{{ this.lin4List[0] }}</td>
            <td>{{ this.lin4List[1] }}</td>
            <td>{{ this.lin4List[2] }}</td>
            <td>{{ this.lin4List[3] }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import apiService from "@/request/api";
import anhui from "@/assets/anhui.json";
import zhejiang from "@/assets/zhejiang.json";
import shanghaishi from "@/assets/shanghaishi.json";
import jiangshu from "@/assets/jiangshu.json";

import Options from "./options.js";
import * as Echarts from "echarts";
import moment from "moment";
export default {
  data() {
    return {
      city: "上海",
      Options: Options,
      zhibiao: ["经济发展", "GDP(亿元)"],
      startYear: "",
      endYear: "",
      year:"",
      mincolor: 0,
      maxcolor: 500,
      defaultYear: "",
      dataList: [],
      dataList1: [],
      dataListMap: [],
      xDate: [],
      yData: [],
      map: null,
      map1: null,
      charts1: "",
      charts2: "",
      charts3: "",
      charts4: "",
      charts5: "",
      charts6: "",
      yearList: [],
      adultZAList: [0, 0, 0, 0, 0, 0],
      childZAList: [0, 0, 0, 0, 0, 0],
      adultFZAList: [0, 0, 0, 0],
      childFZAList: [0, 0, 0, 0],
      Cdsum: [],
      Assum: [],
      Hgsum: [],
      Cusum: [],
      Pbsum: [],
      Znsum: [],
      Nisum: [],
      Crsum: [],
      lin1List: [0,0,0,"是"],
      lin2List: [0,0,0,"是"],
      lin3List: [0,0,0,"是"],
      lin4List: [0,0,0,"是"],
      // 地图数据
      tableshow1:true,
      tableshow2:true,
      pickerOptions: {
        disabledDate(time) {

          // return false;
          return time.getFullYear() < 2000 || time.getFullYear() > 2030;
        }
      },
    };
  },
  methods: {
    handleChangeCity(value) {
      console.log(value, "cityvalue", this.city);

      this.getlist1();
    },
    handleChangeZb(value) {
      console.log(value);
      this.init();
    },
    async handleChangeMapYear(value) {
      console.log(this.defaultYear);
      if(value == 1){

      }else{
        this.map.dispose()
        this.initEcharts();
      }
      
      this.charts1.clear();
      this.charts2.clear();
      this.charts3.clear();
      this.charts4.clear();
      this.charts5.clear();
      this.charts6.clear();
      
      this.getlist1();
      
     
      this.getlist2();
      this.getlist3();
    },
    handleChangeEndYear(value) {
      const sYear = new Date(this.startYear).getFullYear();
      const eYear = new Date(this.endYear).getFullYear();
      if (sYear < eYear || sYear == eYear) {
        this.getlist1();
      } else {
        this.$message.error("开始年份需早于或等于截至年份");
      }
    },
    handleChangeStartYear(value) {
      this.initEcharts();
    },
    async initEcharts() {
      this.dataList = [];
      let numberlist = []
      const params = {
        all: 1,
        page_size: 10000,
        page: 1,
        year: new Date(this.defaultYear).getFullYear(),
        min_year: "",
        max_year: "",
        city: "",
        province: "",
        factors: "",
        type: "ΣHM",
      };
      const res = await apiService.metaldensity(params);
      let list = res.data.results;
      for(var i =0;i<list.length;i++){
        let city =list[i].city.replace("市","")
        city = city.replace(/\s/g, "")
        console.log(city)
        this.dataList.push({
              name: city + "市",
              value: list[i].value,
            });
            numberlist.push(Number(list[i].value) )
      }
      if(list.length !== 0){
            this.maxcolor = parseInt(Math.max(...numberlist))+1;
      this.mincolor = parseInt(Math.min(...numberlist))-1;
      }

  
      console.log(list, "地图数据");
      var csj = {
        type: "FeatureCollection",
        features: shanghaishi.features.concat(
          zhejiang.features,
          anhui.features,
          jiangshu.features
        ),
      };

      const _this = this;
      _this.map = Echarts.init(this.$refs["map"]);
      const option = {
        series: [
          {
            name: "城市",
            type: "map",
            geoIndex: 0,
            data: _this.dataList,
          },
        ],
        geo: {
          //地图配置
          map: "csj",
          zoom: 1.2,
          // roam: true,
          itemStyle: {
            //地图区域样式
            normal: {
              borderColor: "#5089ec",
              borderWidth: 1,
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.10,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 102, 154, 0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 102, 154, .4)", // 100% 处的颜色
                  },
                ],
              },
            },
            emphasis: {
              //高亮样式
              areaColor: "#2386AD",
            },
          },
          //   regions: [{
          //     name: '上海市', // 省份名，确保是 ECharts 中有的省份名
          //     itemStyle: {
          //         normal: {
          //             areaColor: 'red',
          //             borderColor: 'yellow' // 广东省份的边界颜色
          //         },
          //         emphasis: {
          //             areaColor: 'red'
          //         }
          //     }
          // }],

          label: {
            //文本标签样式
            normal: {
              show: true,
              textStyle: {
                color: "#fff",
                fontSize:16
              },
            },
            emphasis: {
              //高亮样式
              textStyle: {
                color: "yellow",
              },
            },
          },
          // 鼠标悬浮提示框
        },
        visualMap: {
          // min: _this.mincolor,
          // max: _this.maxcolor,
          min: 0,
          max: 500,
          // min:0,
          // max:,
          calculable: false,
          left: "left",
          top: "bottom",
          textStyle:{
                    fontSize: 18,//字体大小
                    color: '#ffffff'//字体颜色
                  },

          text: ["高", "低"], //取值范围的文字
          // pieces: [
          // { min: 481, max: 500, color: "#ff2121" },
          // { min: 461, max: 480, color: "#f00056" },
          // { min: 441, max: 460, color: "#ff461f" },
          // { min: 421, max: 440, color: "#ff7500" },
          // { min: 401, max: 420, color: "#ff8c31" },
          // { min: 381, max: 400, color: "#fa8c35" },
          // { min: 361, max: 380, color: "#ffa400" },
          // { min: 341, max: 360, color: "#ffa631" },
          // { min: 321, max: 340, color: "#fff143" },
          // { min: 301, max: 320, color: "#eaff56" },
          // { min: 281, max: 300, color: "#bce672" },
          // { min: 261, max: 280, color: "#c9dd22" },
          // { min: 241, max: 260, color: "#bddd22" },
          // { min: 221, max: 240, color: "#9ed048" },
          // { min: 201, max: 220, color: "#96ce54" },
          // { min: 0, max: 200, color: "#00bc12" },


         

          //           ],
          inRange: {
            // color:_this.colorfw , //取值范围的颜色
            // color: ["green", "red"], //取值范围的颜色
            color: ['#00bc12', '#3de1ad', '#70f3ff','#44cef6','#4b5cc4','#3b2e7e','#003371','#fff143','#ffa400','#ff7500','#ff2121']
          },
          show: true, //图注
        },
        tooltip: {
          
          formatter: function (params) {
            // console.log(params,"数据")
            if (isNaN(params.value)) {
              return params.seriesName + "<br />" + params.name + "：暂无数据";
            } else {
              return params.seriesName + "<br />" + params.name + Number( params.value).toFixed(3)+"mg/kg";
            }
          },
        },
      };
      Echarts.registerMap("csj", csj);
      _this.map.setOption(option);
      _this.map.on("click", function (params) {
        console.log(params.name);
        _this.city = params.name.replace("市", "");
        console.log(111, _this.city);
        _this.handleChangeMapYear(1);
      });
      // charts.dispatchAction({
      //   type: 'highlight',
      //   seriesIndex: 0,
      //   dataIndex: charts.getOption().series[0].data.findIndex(item => item.name === "上海市")
      // });
    },

    async initEcharts1() {
      const _this = this;

      this.charts1 = Echarts.init(this.$refs["echarts1"]);
      // 默认数据
      let seriesData = {
        categories: this.yearList,
        series: [
          {
            name: "Cd",
            data: this.Cdsum,
          },
          {
            name: "As",
            data: this.Assum,
          },
          {
            name: "Hg",
            data: this.Hgsum,
          },
          {
            name: "Cu",
            data: this.Cusum,
          },
        ],
      };
      const colorList = [
        "#1165b2",
        "#b53333",
        "#af620f",
        "#90980c",
        "#20927f",
        "#2726ac",
        "#8c26ac",
        "#6721c4",
      ];
      let series = [];
      seriesData.series.forEach((item, index) => {
        console.log(seriesData.series.length - 1, index, "0909");
        series.push({
          name: item.name,
          type: "line",
          data: item.data,
          symbolSize: 7,
          symbol: "circle",
          smooth: true,
          yAxisIndex: 0,
          showSymbol: true,
          lineStyle: {
            width: 2,
            color: new Echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: colorList[index],
              },
              {
                offset: 1,
                color: colorList[index],
              },
            ]),
          },
          itemStyle: {
            color: colorList[index], // 设置圆形的填充色
            borderColor: "#ffffff", // 设置边框颜色
            borderWidth: 1, // 设置边框宽度
          },
        });
      });
      let option = {
        backgroundColor: "#00000000",
        //你的代码
        legend: {
          icon: "circle",
          top: "5%",
          right: "5%",
          itemWidth: 10,
          itemGap: 20,
          textStyle: {
            color: "#fff",
            fontSize:16
          },
        },
        grid: {
          top: "25%",
          bottom: "15%",
        },
        tooltip: {
          
          trigger: "axis",
          formatter: function (params) {
            var str = `${params[0].name}<br/>`;
            params.forEach((par) => {
              str += `${par.marker} ${par.seriesName}：${par.value} 
               (mg/kg)
              <br/>`;
            });
            return str;
          },
          position: 'right',
          // position: function (point, params, dom, rect, size) {
          //   return [point[0], '10%']; // 在鼠标所在的 x 轴位置，y 轴位置离图表顶部距离为 10%
          // }
        },
        //dataZoom 组件 用于区域缩放
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: [0, 1, 2, 3, 4, 5, 6, 7],
            realtime: true,
            //移动端展示方式
            handleSize: "100%",
            start: 0,
            end: 30,
            height: 10,
            bottom: 10,
          },
        ],
        xAxis: [
          {
            type: "category",
            data: seriesData.categories ? seriesData.categories : [],
            axisLine: {
              lineStyle: {
                color: "#3DECFF",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#fff",
                fontSize: 16,
              },
              // 默认x轴字体大小
              fontSize: 16,
              // margin:文字到x轴的距离
              margin: 15,
            },
            axisPointer: {
              label: {
                // padding: [11, 5, 7],
                padding: [0, 0, 10, 0],
                // 这里的margin和axisLabel的margin要一致!
                margin: 15,
                // 移入时的字体大小
                fontSize: 12,
                backgroundColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      // offset: 0.9,
                      offset: 0.86,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      offset: 0.86,
                      color: "#33c0cd", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#33c0cd", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "浓度：mg/kg",
            nameTextStyle: {
              color: "#fff",
              fontSize:16
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "rgba(255,255,255,0.5)",
              },
            },
          },
        ],
        series: [...series],
      };
      this.charts1.setOption(option);
    },
    async initEcharts2() {
      const _this = this;

      this.charts2 = Echarts.init(this.$refs["echarts2"]);
      // 默认数据
      let seriesData = {
        categories: this.yearList,
        series: [
          {
            name: "Pb",
            data: this.Pbsum,
          },
          {
            name: "Zn",
            data: this.Znsum,
          },
          {
            name: "Ni",
            data: this.Nisum,
          },
          {
            name: "Cr",
            data: this.Crsum,
          },
        ],
      };
      const colorList = [
        "#1165b2",
        "#b53333",
        "#af620f",
        "#90980c",
        "#20927f",
        "#2726ac",
        "#8c26ac",
        "#6721c4",
      ];
      let series = [];
      seriesData.series.forEach((item, index) => {
        console.log(seriesData.series.length - 1, index, "0909");
        series.push({
          name: item.name,
          type: "line",
          data: item.data,
          symbolSize: 7,
          symbol: "circle",
          smooth: true,
          yAxisIndex: 0,
          showSymbol: true,
          lineStyle: {
            width: 2,
            color: new Echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: colorList[index],
              },
              {
                offset: 1,
                color: colorList[index],
              },
            ]),
          },
          itemStyle: {
            color: colorList[index], // 设置圆形的填充色
            borderColor: "#ffffff", // 设置边框颜色
            borderWidth: 1, // 设置边框宽度
          },
        });
      });
      let option = {
        backgroundColor: "#00000000",
        //你的代码
        legend: {
          icon: "circle",
          top: "5%",
          right: "5%",
          itemWidth: 10,
          itemGap: 20,
          textStyle: {
            color: "#fff",
            fontSize:16
          },
        },
        grid: {
          top: "25%",
          bottom: "15%",
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var str = `${params[0].name}<br/>`;
            params.forEach((par) => {
              str += `${par.marker} ${par.seriesName}：${par.value}(mg/kg)
              <br/>`;
            });
            return str;
          },
        },
        //dataZoom 组件 用于区域缩放
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: [0, 1, 2, 3, 4, 5, 6, 7],
            realtime: true,
            //移动端展示方式
            handleSize: "100%",
            start: 0,
            end: 30,
            height: 10,
            bottom: 20,
          },
        ],
        xAxis: [
          {
            type: "category",
            data: seriesData.categories ? seriesData.categories : [],
            axisLine: {
              lineStyle: {
                color: "#3DECFF",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#fff",
              },
              // 默认x轴字体大小
              fontSize: 16,
              // margin:文字到x轴的距离
              margin: 15,
            },
            axisPointer: {
              label: {
                // padding: [11, 5, 7],
                padding: [0, 0, 10, 0],
                // 这里的margin和axisLabel的margin要一致!
                margin: 15,
                // 移入时的字体大小
                fontSize: 12,
                backgroundColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      // offset: 0.9,
                      offset: 0.86,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      offset: 0.86,
                      color: "#33c0cd", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#33c0cd", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "浓度：mg/kg",
            nameTextStyle: {
              color: "#fff",
              fontSize:16
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "rgba(255,255,255,0.5)",
              },
            },
          },
        ],
        series: [...series],
      };
      this.charts2.setOption(option);
    },
    initEcharts3() {
      const _this = this;
      this.charts3 = Echarts.init(this.$refs["echarts3"]);
      let information = {
        dataArray: [
          {
            name: "经口摄入",
            value: this.adultZAList[0],
          },
          {
            name: "皮肤接触",
            value: this.adultZAList[1],
          },
          {
            name: "呼吸吸入",
            value: this.adultZAList[2],
          },

        ],
        colorArray: [
          "#1165b2",
          "#b53333",
          "#af620f",
          "#90980c",
          "#20927f",
          "#2726ac",
          "#8c26ac",
          "#6721c4",
        ],
      };
      let option = {
        // backgroundColor: "#021032",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(9,40,84,0.10)",
          borderColor: "rgba(9,40,84,0.10)",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
          // formatter: "{b} : {c} ({d}%)",
          formatter: function (params) {
            return (
              '<span style="margin-right: 5px; border-radius: 50%; display: inline-block; width:14px; height: 14px; vertical-align: middle; background-color: ' +
              params.color +
              ';"></span>' +
              params.name +
              "&nbsp;&nbsp;<span style='font-weight:bold'>" +
              Number(params.value).toExponential(3) +
              "</span>"
              +'('+params.percent+'%)'
            );
          },
        },
        title: {
          text: "成人致癌不同暴露途径占比",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
          },
        },
        legend: {
          show: true,
          right: "center",
          bottom: "10%",
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          width: "240",
          textStyle: {
            //图例文字的样式
            color: "#b4e4ff",
            fontSize: 14,
            // 给出高度和rich对象，实现图标与文字居中对齐
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        series: [
          {
            color: information.colorArray,
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "40%"],
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: information.dataArray,
          },
          {
            // 外环
            type: "pie",
            silent: true, //取消高亮
            radius: ["0", "53%"],
            center: ["50%", "40%"],
            data: [100],
            itemStyle: {
              color: "rgba(18, 63, 115, 0.3)",
            },
            label: {
              show: false,
            },
            z: 0,
          },
        ],
      };
      this.charts3.setOption(option);
    },
    initEcharts4() {
      const _this = this;
      this.charts4 = Echarts.init(this.$refs["echarts4"]);
      let information = {
        dataArray: [
          {
            name: "经口摄入",
            value: this.childZAList[0],
          },
          {
            name: "皮肤接触",
            value: this.childZAList[1],
          },
          {
            name: "呼吸吸入",
            value: this.childZAList[2],
          },

        ],
        colorArray: [
          "#1165b2",
          "#b53333",
          "#af620f",
          "#90980c",
          "#20927f",
          "#2726ac",
          "#8c26ac",
          "#6721c4",
        ],
      };
      let option = {
        // backgroundColor: "#021032",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(9,40,84,0.10)",
          borderColor: "rgba(9,40,84,0.10)",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
          formatter: function (params) {
            return (
              '<span style="margin-right: 5px; border-radius: 50%; display: inline-block; width:14px; height: 14px; vertical-align: middle; background-color: ' +
              params.color +
              ';"></span>' +
              params.name +
              "&nbsp;&nbsp;<span style='font-weight:bold'>" +
              Number(params.value).toExponential(3) +
              "</span>"
              +'('+params.percent+'%)'
            );
          },
          // formatter: "{b} : {c} ({d}%)",
        },
        title: {
          text: "儿童致癌不同暴露途径占比",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
          },
        },
        legend: {
          show: true,
          right: "center",
          bottom: "10%",
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          width: "250",
          textStyle: {
            //图例文字的样式
            color: "#b4e4ff",
            fontSize: 14,
            // 给出高度和rich对象，实现图标与文字居中对齐
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        series: [
          {
            color: information.colorArray,
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "40%"],
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: information.dataArray,
          },
          {
            // 外环
            type: "pie",
            silent: true, //取消高亮
            radius: ["0", "53%"],
            center: ["50%", "40%"],
            data: [100],
            itemStyle: {
              color: "rgba(18, 63, 115, 0.3)",
            },
            label: {
              show: false,
            },
            z: 0,
          },
        ],
      };
      this.charts4.setOption(option);
    },
    initEcharts5() {
      const _this = this;
      this.charts5 = Echarts.init(this.$refs["echarts5"]);
      let information = {
        
        dataArray: [
          {
            name: "经口摄入",
            value: this.adultFZAList[0],
          },
          {
            name: "皮肤接触",
            value: this.adultFZAList[1],
          },
          {
            name: "呼吸吸入",
            value: this.adultFZAList[2],
          },
     
        ],
        colorArray: [
          "#1165b2",
          "#b53333",
          "#af620f",
          "#90980c",
          "#20927f",
          "#2726ac",
          "#8c26ac",
          "#6721c4",
        ],
      };
      let option = {
        // backgroundColor: "#021032",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(9,40,84,0.10)",
          borderColor: "rgba(9,40,84,0.10)",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
          formatter: function (params) {
            return (
              '<span style="margin-right: 5px; border-radius: 50%; display: inline-block; width:14px; height: 14px; vertical-align: middle; background-color: ' +
              params.color +
              ';"></span>' +
              params.name +
              "&nbsp;&nbsp;<span style='font-weight:bold'>" +
              Number(params.value).toExponential(3) +
              "</span>"
              +'('+params.percent+'%)'
            );
          },
          // formatter: "{b} : {c} ({d}%)",
        },
        title: {
          text: "成人非致癌不同暴露途径占比",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
          },
        },
        legend: {
          show: true,
          right: "center",
          bottom: "10%",
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          width: "240",
          textStyle: {
            //图例文字的样式
            color: "#b4e4ff",
            fontSize: 14,
            // 给出高度和rich对象，实现图标与文字居中对齐
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        series: [
          {
            color: information.colorArray,
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "40%"],
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: information.dataArray,
          },
          {
            // 外环
            type: "pie",
            silent: true, //取消高亮
            radius: ["0", "53%"],
            center: ["50%", "40%"],
            data: [100],
            itemStyle: {
              color: "rgba(18, 63, 115, 0.3)",
            },
            label: {
              show: false,
            },
            z: 0,
          },
        ],
      };
      this.charts5.setOption(option);
    },
    initEcharts6() {
      const _this = this;
      this.charts6 = Echarts.init(this.$refs["echarts6"]);
      let information = {
        dataArray: [
          {
            name: "经口摄入",
            value: this.childFZAList[0],
          },
          {
            name: "皮肤接触",
            value: this.childFZAList[1],
          },
          {
            name: "呼吸吸入",
            value: this.childFZAList[2],
          },

        ],
        colorArray: [
          "#1165b2",
          "#b53333",
          "#af620f",
          "#90980c",
          "#20927f",
          "#2726ac",
          "#8c26ac",
          "#6721c4",
        ],
      };
      let option = {
        // backgroundColor: "#021032",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(9,40,84,0.10)",
          borderColor: "rgba(9,40,84,0.10)",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
          formatter: function (params) {
     
            return (
              '<span style="margin-right: 5px; border-radius: 50%; display: inline-block; width:14px; height: 14px; vertical-align: middle; background-color: ' +
              params.color +
              ';"></span>' +
              params.name +
              "&nbsp;&nbsp;<span style='font-weight:bold'>" +
              Number(params.value).toExponential(3) +
              "</span>"
              +'('+params.percent+'%)'
            );
          },
          // formatter: "{b} : {c} ({d}%)".toExponential(),
        },
        title: {
          text: "儿童非致癌不同暴露途径占比",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
          },
        },
        legend: {
          show: true,
          right: "center",
          bottom: "10%",
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          width: "240",
          textStyle: {
            //图例文字的样式
            color: "#b4e4ff",
            fontSize: 14,
            // 给出高度和rich对象，实现图标与文字居中对齐
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        series: [
          {
            color: information.colorArray,
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "40%"],
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: information.dataArray,
          },
          {
            // 外环
            type: "pie",
            silent: true, //取消高亮
            radius: ["0", "53%"],
            center: ["50%", "40%"],
            data: [100],
            itemStyle: {
              color: "rgba(18, 63, 115, 0.3)",
            },
            label: {
              show: false,
            },
            z: 0,
          },
        ],
      };
      this.charts6.setOption(option);
    },
    async init() {
      this.initEcharts();
      this.getlist1();
       this.getlist2();
      this.getlist3();
     
    },
    async getlist1() {
      let city = this.city
      if(city == "合肥"){
        city="合 肥"
      }
      if(city == "淮北"){
        city="淮 北"
      }
      if(city == "亳州"){
        city="亳 州"
      }
      if(city == "宿州"){
        city="宿 州"
      }
      if(city == "蚌埠"){
        city="蚌 埠"
      }
      if(city == "阜阳"){
        city="阜 阳"
      }
      if(city == "淮南"){
        city="淮 南"
      }
      if(city == "滁州"){
        city="滁 州"
      }
      if(city == "六安"){
        city="六 安"
      }
      const params = {
        all: 1,
        page_size: 10000,
        page: 1,
        year: "",
        min_year: "",
        max_year: "",
        city: city,
        province: "",
        factors: "",
        type: "",
      };
      const res = await apiService.metaldensity(params);
      let list = res.data.results;
      console.log(res, "重金属数据");
      this.yearList = [];
      this.Cdsum = [];
      this.Assum = [];
      this.Hgsum = [];
      this.Cusum = [];
      this.Pbsum = [];
      this.Znsum = [];
      this.Nisum = [];
      this.Crsum = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].type == "Cd") {
          this.yearList.push(list[i].year);
        }
      }
      for (var i = 0; i < this.yearList.length; i++) {
        this.Cdsum[i] = 0;
        this.Assum[i] = 0;
        this.Hgsum[i] = 0;
        this.Cusum[i] = 0;
        this.Pbsum[i] = 0;
        this.Znsum[i] = 0;
        this.Nisum[i] = 0;
        this.Crsum[i] = 0;
        for (var j = 0; j < list.length; j++) {
          if (list[j].year == this.yearList[i]) {
            if (list[j].type == "Cd") {
              this.Cdsum[i] = Number(list[j].value);
            }
            if (list[j].type == "As") {
              this.Assum[i] = Number(list[j].value);
            }
            if (list[j].type == "Hg") {
              this.Hgsum[i] = Number(list[j].value);
            }
            if (list[j].type == "Cu") {
              this.Cusum[i] = Number(list[j].value);
            }

            if (list[j].type == "Pd") {
              this.Pbsum[i] = Number(list[j].value);
            }

            if (list[j].type == "Zn") {
              this.Znsum[i] = Number(list[j].value);
            }

            if (list[j].type == "Ni") {
              this.Nisum[i] = Number(list[j].value);
            }

            if (list[j].type == "Cr") {
              this.Crsum[i] = Number(list[j].value);
            }
          }
        }
      }

      this.initEcharts1();
      this.initEcharts2();
    },
    async getlist2() {
      const params = {
        all: 1,
        page_size: 10000,
        page: 1,
        year: new Date(this.defaultYear).getFullYear(),
        min_year: "",
        max_year: "",
        city: this.city,
        province: "",
        factors: "",
        type: "",
        is_adult:""
      };
      this.tableshow1 = false
      const res = await apiService.metalcancerrisk(params);
      let list = res.data.results;
      console.log(list, "重金属致癌风险");
        let adultzazsr = "否"
      let childzazsr = "否"
      for (var i = 0; i < list.length; i++) {
       if(list[i].is_adult == true){
        if(list[i].type == "经口摄入"){
          this.adultZAList[0] = list[i].value
        }
        if(list[i].type == "皮肤接触"){
          this.adultZAList[1] = list[i].value
        }
        if(list[i].type == "呼吸吸入"){
          this.adultZAList[2] = list[i].value
        }
        if(list[i].type == "总摄入"){
          if(Number(list[i].value)>0.000001){
            adultzazsr = "是"
          }else{
             adultzazsr = "否"
          }
        }
       }else{
        if(list[i].type == "经口摄入"){
          this.childZAList[0] = list[i].value
        }
        if(list[i].type == "皮肤接触"){
          this.childZAList[1] = list[i].value 
        }
        if(list[i].type == "呼吸吸入"){
          this.childZAList[2] = list[i].value
        }
        if(list[i].type == "总摄入"){
          console.log("儿童致癌",Number(list[i].value) >0.000001,Number(list[i].value))
          if(Number(list[i].value) >0.000001){
            console.log("儿童致癌",Number(list[i].value) >0.000001)
            childzazsr = "是"
            
          }
          else{
            childzazsr = "否"
          }
        }
        }
      }

      this.lin4List[0] = Number(this.adultZAList[0]).toExponential(3)
      this.lin4List[1] =  Number(this.adultZAList[2]).toExponential(3)
      this.lin4List[2] =  Number(this.adultZAList[1]).toExponential(3)
      this.lin4List[3] =  adultzazsr
      this.lin2List[0] =  Number(this.childZAList[0]).toExponential(3)
      this.lin2List[1] =  Number(this.childZAList[2]).toExponential(3)
      this.lin2List[2] =  Number(this.childZAList[1]).toExponential(3)
      this.lin2List[3] =  childzazsr
      console.log(this.lin2List[3],this.lin4List[3])
      this.tableshow1 = true
      this.initEcharts3();
      this.initEcharts4();
      // this.initEcharts5();
      // this.initEcharts6();
    },
    async getlist3() {
      const params = {
        all: 1,
        page_size: 10000,
        page: 1,
        year: new Date(this.defaultYear).getFullYear(),
        min_year: "",
        max_year: "",
        city: this.city,
        province: "",
        factors: "",
        type: "",
        is_adult:""
      };
      this.tableshow2 = false
      const res = await apiService.MetalNonCancerRisk(params);
      let list = res.data.results;
      console.log(list, "重金属非致癌风险");
      let adultfzazsr = "否"
      let childfzazsr = "否"
      for (var i = 0; i < list.length; i++) {
       if(list[i].is_adult == true){
        if(list[i].type == "经口摄入"){
          this.adultFZAList[0] = list[i].value
        }
        if(list[i].type == "皮肤接触"){
          this.adultFZAList[1] = list[i].value
        }
        if(list[i].type == "呼吸吸入"){
          this.adultFZAList[2] = list[i].value
        }
        if(list[i].type == "总摄入"){
          if(Number(list[i].value) >1){
            adultfzazsr="是"
          }
          else{
            adultfzazsr = "否"
          }
        }
       }else{
        if(list[i].type == "经口摄入"){
          this.childFZAList[0] = list[i].value
        }
        if(list[i].type == "皮肤接触"){
          this.childFZAList[1] = list[i].value 
        }
        if(list[i].type == "呼吸吸入"){
          this.childFZAList[2] = list[i].value
        }
        if(list[i].type == "总摄入"){
          console.log(Number(list[i].value)>1)
                    if(Number(list[i].value)>1){
            childfzazsr="是"
          }
          else{
            childfzazsr = "否"
          }
        }
        }

      }
     
      this.lin3List[0] = Number(this.adultFZAList[0]).toFixed(3)
      this.lin3List[1] = Number(this.adultFZAList[2]).toFixed(3)
      this.lin3List[2] = Number(this.adultFZAList[1]).toFixed(3)
      this.lin3List[3] = adultfzazsr
      this.lin1List[0] = Number(this.childFZAList[0]).toFixed(3)
      this.lin1List[1] = Number(this.childFZAList[2]).toFixed(3)
      this.lin1List[2] = Number(this.childFZAList[1]).toFixed(3)
      this.lin1List[3] = childfzazsr
      console.log(this.lin1List[3],this.lin3List[3])
      this.tableshow2 = true
      this.initEcharts5();
      this.initEcharts6();
    },
  },
  watch:{
    defaultYear(val,value){
      this.year = new Date(val).getFullYear()
    }
  },
  mounted() {
    this.defaultYear = new Date();
    this.init();
  },
};
</script>
<style  lang="scss">
.shjjzb {
  height: 100%;
  display: flex;
  justify-content: space-between;
  input {
    background-color: rgba(0, 0, 0, 0) !important;
    border-color: #01aed2;
    color: #fff;

    // height: 20px;
    font-size: 12px;
    border-radius: 8px;
  }
  .operate {
    width: 250px;
    flex: 1;
    display: flex;
    flex-direction: column;
    .operateBox {
      display: flex;
      justify-content: space-between;
      // flex-direction: column;
      // align-items: end;
      .operateItem {
        width: 200px;
        margin-bottom: 30px;
      }
      .el-select {
        width: 200px;
      }
    }
    .yearBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-input {
        width: 200px !important;
      }
    }
    .grid {
      display: flex;
      width: 98%;
      border: 1px solid #01aed2;
      margin: 40px 0 40px 10px;

      .gridHead {
        width: 80px;
        border-right: 1px solid #01aed2;
        div {
          text-align: center;
          line-height: 38px;
        }
        div:nth-child(1) {
          border-bottom: 1px solid #01aed2;
        }
      }
      .gridData {
        flex: 1;
        display: flex;
        overflow: hidden;
        .gridItem {
          min-width: 100px;
          border-right: 1px solid #01aed2;
          div {
            text-align: center;
            line-height: 38px;
          }
          div:nth-child(1) {
            border-bottom: 1px solid #01aed2;
          }
        }
      }
      .gridData:hover {
        overflow: auto;
      }
      .gridData::-webkit-scrollbar {
        height: 5px;
        height: 5px;
      }
      .gridData::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #01aed2;
        cursor: pointer;
      }

      .gridData::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
    .stitle {
      height: 40px;
      background-image: url(@/imgs/2-小标题.png);
      background-size: cover;
      line-height: 38px;
      padding-left: 20px;

      width: 200px;
    }
    .echarts1 {
      width: 100%;
      flex: 1;
    }
    .echarts2 {
      width: 100%;
      flex: 1;
    }
  }
  .mapBox {
    flex: 1;
    // display: flex;
    // align-items: center;
    position: relative;
    .mapYear {
      position: absolute;
      right: 10px;
      top: 38px;
      width: 100px;
    }
    .map {
      width: 100%;
      height: 90%;
    }
  }
  .echartsBox {
    flex: 1;
    display: flex;
    flex-direction: column;
    .glzb {
      flex: 1;
      display: flex;
      flex-direction: column;
      .glzb_line {
        display: flex;
        flex: 1;
        .glzb_line_item {
          width: 80%;
          height: 100%;
          // border: 1px solid gray;
        }
      }
    }
    .zaTable {
      height: 150px;
      table{
        border: 1px solid #ccc;
        width:100%;
        height: 140px;
        
      } 
      /* 偶数行背景色 */
      table tr:nth-child(1) {
        background-color: #1165b2;
      }
      .td1{
        background-color: #1165b2;
      }
      

      tr td {
        text-align: center;
        font-size: 16px;
      }
      // tr{
      //   height: 28px;
      // }
      td{
        width: 20%;
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 20px;
    padding: 4px;
    color: rgb(5, 225, 250);
    .yuan {
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: rgb(5, 225, 250);
      margin-right: 4px;
    }
  }
}
</style>